// extracted by mini-css-extract-plugin
export default {"root":"close-button_root__WM3ms"};